import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { userAvatar } from 'cms/utils';
import { loadCourseParticipants, loadCourseReferees } from 'cms/utils/Network';

export default function SelectCoursePeopleModalController( course,props) {

  const [courseParticipants, setCourseParticipants] = useState(false);
  const [courseReferees, setCourseReferees] = useState(false);
  
  const [pages, setPages] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (props.isOpen) {
      setModalIsOpen(props.isOpen);
    }
  }, [props.isOpen]);

  const { isLoading, data ,refetch } = useQuery(['courseParticipants', course , page], () =>
    loadCourseParticipants(course, page, 30),
    {
      onSuccess: (data) => { 
        _createPagesArray(data)
        _setCourseParticipants(data)
      },
    }
  );

  const _setCourseParticipants = (data) =>{
    let results;
    if (data.results) {
      if (props.excludeIds) {
        results = data.results.filter((item) => !props.excludeIds.includes(item.id));
        setCourseParticipants(results);
      } else if (props.exlclude_usertalents) {
        results = data.results.filter((item) => !props.exlclude_usertalents.includes(item.usertalent.id));
        setCourseParticipants(results);
      } else {
        setCourseParticipants(data.results);
      }
    }
  }

  const { loading_referees, referees, refetch_referees } = useQuery(['courseReferees', course, page], () =>
    loadCourseReferees(null, course, page, 50),
    {
      onSuccess: (referees) => { 
        _createPagesArray(referees)
        _setRefereeData(referees)
      },
    }
  );

  const _setRefereeData = (data) => {
    let results;
    if (data) {
      if (props.excludeIds) {
        results = data.filter((item) => !props.excludeIds.includes(item.id));
        setCourseReferees(results);
      } else {
        setCourseReferees(data);
      }
    }
  }

  const _createPagesArray = (data)=>{
    if (data && data.count) {
      const page_count = data.count % 30 === 0 ? parseInt(data.count / 30) : parseInt(data.count / 30) + 1;
      const pages_array = range(1, page_count);
      setPages(pages_array);
    }
  }


  function range(start, end) {
    return Array.apply(0, Array(end)).map((element, index) => index + start);
  }

  const closeModal = () => {
    setModalIsOpen(false);
    props.onClose();
  };

  const loadPage = async (e, page) => {
    e.preventDefault();
    setPage(page)
    await refetch();
  };

  const setSelectedItem = (item) => {
    if (props.setSelectedItem) props.setSelectedItem(item);
    setModalIsOpen(false);
  };

  return {
    modalIsOpen,
    closeModal,
    isLoading,
    pages,
    page,
    loadPage,
    setSelectedItem,
    courseParticipants,
    userAvatar,
    courseReferees
  };;
}
